"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.last = void 0;
var at_1 = require("./at");
/** @internal */
var last = function (array) {
    return (0, at_1.at)(array, array.length - 1);
};
exports.last = last;
